<template>
  <div>
    <v-row>
      <v-col cols="12">
        <input-documento :cnpj="habilitaDoc" :label="docNomeRazao.doc" v-model="model.DocumentoFederal" required />
      </v-col>
      <v-col cols="12">
        <input-text :label="docNomeRazao.nomeRazao" v-model="model.Nome" required />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    value: null
  },
  data () {
    return {

    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
        return this.value
      }
    },
    habilitaDoc () {
      var PF = this.$param.EST_PRODUTOS.map((p) => p.TipoPessoa).includes(('PF'))
      var PJ = this.$param.EST_PRODUTOS.map((p) => p.TipoPessoa).includes(('PJ'))
      if (PF) { return false } else if (PJ) { return true } else { return false }
    },
    docNomeRazao () {
      var PF = this.$param.EST_PRODUTOS.map((p) => p.TipoPessoa).includes(('PF'))
      var PJ = this.$param.EST_PRODUTOS.map((p) => p.TipoPessoa).includes(('PJ'))
      var doc = ''
      var nomeRazao = ''
      if (PF && PJ) {
        doc = 'CNPJ/CPF'
        nomeRazao = 'Nome/Razão Social'
        return { doc, nomeRazao }
      } else if (PF) {
        doc = 'CPF'
        nomeRazao = 'Nome'
        return { doc, nomeRazao }
      } else {
        doc = 'CNPJ'
        nomeRazao = 'Razão Social'
        return { doc, nomeRazao }
      }
    }
  }
}
</script>
